import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'smart-autority-view',
  templateUrl: './autority-view.component.html',
  styleUrls: ['./autority-view.component.scss']
})
export class AutorityViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
